
import fetchGeneros from "./fetchGeneros";
import obtenerGenero from "./obtenerGenero";

/**
 * Funcion que se encarga de hacer fetch para obtener las peliculas o series populares.
 * @param {String} filtro Si queremos cargar 'peliculas' o 'series'.
 */

const fetchPopulares = async (filtro = 'movie') => {
  const tipo = filtro === 'movie' ? 'movie' : 'tv';

  const url = `https://api.themoviedb.org/3/${tipo}/popular?api_key=71215a991e35e69723fc495d6d25c8fc&language=es-ARG&region=US&page=1`;

  try {
    const respuesta = await fetch(url);
    const datos = await respuesta.json();
    const resultados = datos.results;

    const generos = await fetchGeneros();
    // Obtenemos el genero de cada resultado y lo agregamos al objeto de resultados.
    resultados.forEach((resultado) => {
        resultado.genero = obtenerGenero(resultado.genre_ids[0], generos); 
    });

    return resultados;
  } catch (e) {
    console.log(e); 
  }
};

export default fetchPopulares;
